import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup
    .object()
    .shape({
      phoneNumber: yup
        .string()
        .nullable()
        .test(
          'phone-number-length',
          formatMessage({
            id: 'PHONE_NUMBER_MUST_BE_EXACTLY_10_DIGITS',
            defaultMessage: 'Phone number must be exactly 10 digits',
          }),
          value => {
            if (value == null || String(value).trim() === '') {
              return true;
            }
            const digits = String(value).replace(/\D/g, '');
            return digits.length === 10;
          },
        ),
      description: yup.string().nullable(),
    })
    .test(
      'at-least-one-required',
      formatMessage({
        id: 'AT_LEAST_ONE_FIELD_IS_REQUIRED',
        defaultMessage: 'At least one field is required',
      }),
      value =>
        value &&
        typeof value === 'object' &&
        !Array.isArray(value) &&
        Object.values(value).some(val => val && val !== ''),
    );

export default validationSchema;
